module.exports = __webpack_public_path__ + "img/mascote-lyra.db4cd4e3.png";